// extracted by mini-css-extract-plugin
module.exports = {"form":"Player_form__2NcyP","label":"Player_label__UaXzd","error":"Player_error__2AiTP","input":"Player_input__1GF31"};